import React from "react";

import { ErrorDetail } from "../../../components/ErrorDetail/ErrorDetail";

export const Error502: React.FC = () => {
  return (
    <>
      <ErrorDetail variant="error502" />
    </>
  );
};
